import { IAsyncOperationState } from '../../../../api/realtime/types';
import {
  DEFAULT_COMPLETED_MESSAGE,
  DEFAULT_OPERATION_TITLE,
  OPERATION_COMPLETED_MESSAGES,
  OPERATION_TITLES,
  STAGE_LABELS,
} from './constants';

// the server may add steps: an unknown key shows as words ('CountingVehicles': 'Counting vehicles')
const humanize = (key: string): string => {
  const words = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const getOperationTitle = (operation: IAsyncOperationState): string =>
  OPERATION_TITLES[operation.subType] ?? DEFAULT_OPERATION_TITLE;

export const getCompletedMessage = (operation: IAsyncOperationState): string =>
  OPERATION_COMPLETED_MESSAGES[operation.subType] ?? DEFAULT_COMPLETED_MESSAGE;

export const getOperationDetails = (operation: IAsyncOperationState): string => {
  if (operation.status === 'Queued') return 'Queued…';
  if (operation.status === 'Cancelling') return 'Cancelling…';
  if (!operation.stage) return 'Starting…';
  const { stage, stageIndex, stageCount, processed, total } = operation;
  const step = stageIndex && stageCount ? `Step ${stageIndex} of ${stageCount} · ` : '';
  const counts =
    typeof processed === 'number' && typeof total === 'number' ? ` (${processed} of ${total})` : '';
  return `${step}${STAGE_LABELS[stage] ?? humanize(stage)}${counts}`;
};

/** Until the operation reports some progress, the bar only shows that it is alive. */
export const hasDeterminateProgress = (operation: IAsyncOperationState): boolean =>
  operation.status !== 'Queued' && typeof operation.percent === 'number' && operation.percent > 0;
